import { CheckBox } from 'macaron-frontend-ui'
import { useCallback } from 'react'
import { sva } from '~/styled-system/css'
import {
  useIsMailMagazineSubscriptionVisible,
  useSetSubscribeMailMagazineIkyuNews,
  useSetSubscribeMailMagazinePointCoupon,
} from '../../store/mailMagazineSubscription'
import {
  useSubscribeMailMagazineIkyuNews,
  useSubscribeMailMagazinePointCoupon,
} from '../../store/stateMachine/context'

export const MailMagazineSubscription =
  import.meta.env.VITE_MODE === 'ppg' ? EmptyMailMagazineSubscription : IkyuMailMagazineSubscription

const styles = sva({
  slots: ['container', 'title'],
  base: {
    container: {
      spaceY: '3',
      bg: 'white',
      paddingX: '3',
      paddingBottom: '5',
      paddingTop: '3',
      _pc: { padding: '6' },
    },
    title: {
      fontSize: 'sm',
      fontWeight: 'bold',
      color: 'gray.700',
      _pc: { fontSize: 'md' },
    },
  },
})

function IkyuMailMagazineSubscription() {
  const { isVisible, ikyuNews, pointCoupon, onChangeIkyuNews, onChangePointCoupon } =
    useMailMagazineSubscription()
  if (!isVisible) {
    return null
  }
  const classes = styles()
  return (
    <div className={classes.container}>
      <h2 className={classes.title}>メール受信設定</h2>
      <Item label="一休.comレストランのお得な情報" onChange={onChangeIkyuNews} checked={ikyuNews} />
      <Item
        label="お客様限定のクーポン・ポイントや会員ステージ情報"
        onChange={onChangePointCoupon}
        checked={pointCoupon}
      />
    </div>
  )
}

function useMailMagazineSubscription() {
  const isVisible = useIsMailMagazineSubscriptionVisible()
  // このコンポーネントが表示される時点で会員なので undefined はありえないが、
  // boolean 型を保証するため ?? false している
  const ikyuNews = useSubscribeMailMagazineIkyuNews() ?? false
  const pointCoupon = useSubscribeMailMagazinePointCoupon() ?? false
  const changeIkyuNews = useSetSubscribeMailMagazineIkyuNews()
  const changePointCoupon = useSetSubscribeMailMagazinePointCoupon()
  const onChangeIkyuNews = useCallback(() => {
    changeIkyuNews(!ikyuNews)
  }, [changeIkyuNews, ikyuNews])
  const onChangePointCoupon = useCallback(() => {
    changePointCoupon(!pointCoupon)
  }, [changePointCoupon, pointCoupon])
  return { isVisible, ikyuNews, pointCoupon, onChangeIkyuNews, onChangePointCoupon }
}

function EmptyMailMagazineSubscription() {
  return null
}

function Item({
  label,
  onChange,
  checked,
}: {
  label: string
  onChange: () => void
  checked: boolean
}) {
  return <CheckBox checked={checked} onChange={onChange} label={label} />
}
